<app-header [user]="user()" />

<div class="www-hom">
  <app-home-top [user]="user()" />
  <app-home-about-us />
  <app-home-pillars />
  <app-newsletter-section />
</div>
